module.exports = __webpack_public_path__ + "static/media/pattern-erase.a23fef4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/pattern-erase.svg
// module id = 1265
// module chunks = 37